
import { Component, Vue } from 'vue-property-decorator';
import {GetInstructionFile} from '@/components/utils/GetInstructionFile';

@Component
export default class Rule58ApplicationInstructions extends Vue {      

    affidavit = false;

    mounted(){
        this.affidavit = false;
    }
    
    public downloadInstructions(pdf_name){

        GetInstructionFile(pdf_name);
        
    }

}

